import { html, render } from '@designestate/dees-element';
import * as serviceworker from '@losslessone_private/lele-serviceworker';

import * as domtools from '@designestate/dees-domtools';

import '@losslessone_private/lele-catalog';
import '@losslessone_private/lele-productui-catalog';
import '@social.io_private/catalog';
import '@consentsoftware_private/catalog';

import { commitinfo } from './00_commitinfo_data.js';

const run = async () => {
  const slogan = 'programmable contract management';
  const domtoolsInstance = await domtools.DomTools.setupDomTools();
  domtools.elementBasic.setup();
  await domtoolsInstance.setWebsiteInfo({
    metaObject: {
      title: 'signature.digital - unified signup forms',
      description:
        'One tool to get a grip on your signup efforts.',
      companyWebsiteLink: 'https://lossless.com',
    },
  });
  const swInstance = serviceworker.getServiceWorker();

  const mainTemplate = html`
    <lele-statusbar
      .siteText=${slogan}
      .commitinfo=${commitinfo}
    ></lele-statusbar>
    <lele-productui-navigation
      .domain="${'signature.digital'}"
      .links=${[
        {
          text: 'Features',
          url: '',
        },
        {
          text: 'Partners',
          url: '',
        },
        {
          text: 'Pricing',
          url: '',
        },
      ]}
    ></lele-productui-navigation>
    <lele-productui-header
      domain="signature.digital"
      .sloganBase=${''}
      .sloganVariations="${[
        slogan,
        'digital contractual compliance processes',
        'markdown based contract generation',
        'automated contractual party consent'
      ]}"
    ></lele-productui-header>
    <lele-productui-featuresection
      .features="${[
        'unifies messaging with your customers',
        'supports facebook',
        'supports twitter',
        'supports email',
        'integrates with Google Dialogflow',
        'integrates with Slack',
        'integrates with Microsoft Teams',
        'offers apps for Mac, Windows, Linux, Android and iOS',
        'offers chat widget',
        'offers client api for client side integration',
        'offers admin api for admin side integration',
        'supports integrating your own bot framework',
      ]}"
    ></lele-productui-featuresection>
    <lele-productui-codesection>
      <code>
        <pre>
          /**
           * We have apps. (scroll down to see them)
           * We have chat widgets for your websites (check it out on the bottom right).
           * We have APIs.
           * And we have AWESOME TypeScript packages for our APIs published on npm :)
           */
          
          import * as sioApi from '@signature.digital/api';

          const mySioAccount = sioApi.SioAccount.createFromApiKey('123xyz');

          // yes, it is just rxjs ;)
          mySioAccount.conversationsObservable.subscribe(conversation => {
            // lets do something with a new conversation
            // e.g. you don't want the conversation to pop up in the agent dashboard.
            conversation.preventDefault();

            // subscribe to messages :)
            const messageSubscription = conversation.messageObservable.subscribe(message => {
              if (
                  message.text.contains('hello')
                  && conversation.originDomain === 'mycompany.com' 
                ) {

                // you can inject your own bot logic here
                // let your imagination run free :)

                message.reply('hello there, too!', {
                  delay: 300,
                  fromName: 'My Awesome Bot or Agent Name',
                  fromImageUrl: 'https://mycompany.com/team/peter/profile.jpg'
                })

                // you can then hand over to an agent on the web
                messageSubscription.unsubscribe();
                conversation.handOffToAgentDashboard();
              }
            })

          })
          </pre
        >
      </code>
    </lele-productui-codesection>
    <lele-productui-pricingsection>
      <lele-planselection></lele-planselection>
    </lele-productui-pricingsection>
    <lele-footer .commitinfo=${commitinfo}></lele-footer>
    <consentsoftware-cookieconsent></consentsoftware-cookieconsent>
    <sio-fab style="position: fixed;"></sio-fab>
  `;

  render(mainTemplate, document.body);
};

run();
